<template>
    <div class="service-page global-web">
        <NavBar :white="true"/>
        <Masthead :className="`global-web`" :activeService="5" title="多言語、セキュリティ、<br/>あらゆるニーズに対応" category="Webサイト"
                  :image="require(`../../assets/global-web/icon_Global_Web_Development.svg`)"/>
        <GlobalWebContent />
        <ServiceBox :activeService="5"/>
        <OurWork/>
    </div>
</template>

<script>
    import NavBar from "../../components/NavBar";
    import Masthead from '../../components/service/Masthead'
    import GlobalWebContent from "../../components/service/GlobalWebContent";
    import ServiceBox from "../../components/service/ServiceBox";
    import OurWork from "../../components/service/OurWork";
    import Configuration from "../../utils/configuration";

    export default {
        name: 'GlobalWeb',
        components: {
            NavBar,
            Masthead,
            GlobalWebContent,
            ServiceBox,
            OurWork,
        },
        metaInfo: {
          title: '中国、台湾、東南アジアでのwebサイト制作、運用はオロ',
          meta: [
            {
              property: 'description',
              content: '複数国のグローバルサイトを一括構築、運用。企画、デザイン、翻訳だけでなくSEO、セキュリティを考慮したインフラ構築を含むwebサイト構築サービスを日本基準の品質で提供しています。',
              vmid: 'description'
            },
            {
              property: 'og:title',
              content: '中国、台湾、東南アジアでのwebサイト制作、運用はオロ',
              vmid: 'og:title'
            },
            {
              property: 'og:url',
              content: 'https://www.oro.com/global/service/website-development',
              vmid: 'og:url'
            },
            {
              property: 'og:type',
              content: Configuration.site.meta.og_type,
              vmid: 'og:type'
            },
            {
              property: 'og:site_name',
              content: Configuration.site.meta.og_site_name,
              vmid: 'og:site_name'
            }
          ]
        }
    }
</script>

<style lang="scss">
    .service-page {
        background: #F8F8F8;
        .narbar-menu.bg-white {
            background: #F8F8F8 !important;
        }
        .narbar-menu.bg-dropdown {
            background: #FFF !important;
        }
        .narbar-menu.bg-white.menu-open {
            background: none !important;
        }
        section {
            > .container {
                padding-top: 100px;
                padding-bottom: 100px;
            }

            h5.sub_title {
                font-size: 28px;
                letter-spacing: 1.4px;
                line-height: 40px;
                margin-bottom: 70px;
                font-weight: 700;
            }

            p.sub_content {
                font-size: 16px;
                letter-spacing: 0.8px;
                line-height: 30px;
                margin-bottom: 0;
                font-weight: 400;
                margin-top: 60px;
            }
        }

        .hover-anim {
            &:hover {
                .img-area {
                    img {
                        -webkit-filter: none;
                        -moz-filter: none;
                        filter: none;
                    }
                    .img {
                        -webkit-filter: none;
                        -moz-filter: none;
                        filter: none;
                    }
                }
            }
        }

        .mb {
            .hover-anim {
                .img-area {
                    img {
                        -webkit-filter: none;
                        -moz-filter: none;
                        filter: none;
                    }
                    .img {
                        -webkit-filter: none;
                        -moz-filter: none;
                        filter: none;
                    }
                }
            }
        }

        .img-area {
            img {
                margin-right: 1.5rem;
                height: auto;
                -webkit-filter: grayscale(100%);
                -moz-filter: grayscale(100%);
                filter: grayscale(100%);
                transition: all .5s ease;
                object-fit: contain;
                object-position: left;
                max-width: 100%;

                &:last-child {
                    margin-right: 0;
                }
            }
            .img {
                -webkit-filter: grayscale(100%);
                -moz-filter: grayscale(100%);
                filter: grayscale(100%);
            }
        }

        i {
            &.arrow-right {
                display: inline-block;
                width: 63px;
                height: 13px;
                background: url(../../assets/icons/arrow-right-dark.svg) no-repeat center right;
                background-size: contain;
            }
        }
    }

    @media screen and (max-width: 767px) {
        .service-page {
            section {
                > .container {
                    padding-top: 70px;
                    padding-bottom: 70px;
                }
                h5.sub_title {
                    font-family: 'Noto Sans JP', sans-serif;
                    color: #333333;
                    font-size: 24px;
                    line-height: 1.46;
                    margin-bottom: 35px;
                }
                p.sub_content {
                    font-family: 'Noto Sans JP', sans-serif;
                    color: #333333;
                    font-size: 15.5px;
                    margin-top: 25px;
                }
            }

            .img-area {
                img {
                    width: 100% !important;
                    max-width: 100% !important;
                    margin-right: 0;
                    -webkit-filter: none;
                    -moz-filter: none;
                    filter: none;
                    &.sp-mb-25 {
                        margin-bottom: 25px;
                    }
                }
                .img {
                    width: 100% !important;
                    margin-right: 0;
                    -webkit-filter: none;
                    -moz-filter: none;
                    filter: none;
                }
            }
        }
    }

    @media screen and (min-width: 1920px) {
        .service-page {
            .container {
                max-width: 1364px;
            }

            .container.full {
                max-width: 1920px;
            }
        }
    }

    @media screen and (max-width: 1919px) and (min-width: 1494px) {
        .service-page {
            .container {
                max-width: 1364px;
            }

            .container.full {
                max-width: 100%;
            }
        }
    }

    @media screen and (max-width: 1493px) and (min-width: 1280px) {
        .service-page {
            .container {
                max-width: calc(100% - 110px);
            }

            .container.full {
                max-width: 100%;
            }
        }
    }
</style>
